import React from "react";
import "./Accueil.css";

const Accueil = () => {
  return (
    <div className="Accueil">
      <h1>Accueil</h1>
      <p>
        Ceci est la page : Accueil
      </p>
    </div>
  );
};

export default Accueil;
